import { isGuideSupported } from "@expert/solve-tools";

interface OpenOnCallStartProps {
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
}
export function shouldOpenOnCallStart({
    disableAutomaticOpen,
    isCustomerSession,
    isGuideOpen,
    isLoadingSimplrSession,
}: Readonly<OpenOnCallStartProps>) {
    const isProbingQuestionsGuideAvailable = isGuideSupported("Probing Questions");
    const isADTGuideAvailable = isGuideSupported("ADT Guide");

    const guideToOpen = isProbingQuestionsGuideAvailable
        ? "Probing Questions"
        : isADTGuideAvailable
          ? "ADT Guide"
          : undefined;

    return {
        guideToOpen,
        shouldOpenGuide:
            guideToOpen && !isGuideOpen && isCustomerSession && !disableAutomaticOpen && !isLoadingSimplrSession,
    };
}
